import Modal from 'react-bootstrap/Modal';
import { BDSMForm } from '../../../../../components/form/BDSMForm';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import * as Yup from 'yup';
import { declarePeople, getDeclaredPeople } from '../MenuTodayService';
import { DEFAULT_DATE } from '../../../../../components/common/Constants';
import { toDateString } from '../../../../../utils/TimeUtils';

export const PeopleDeclarationForm = () => {

    const { t } = useTranslation('todayMenu');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const alert = useAlert();
    const [declaredPeople, setDeclaredPeople] = useState(
        {
            date: '',
            littleOnes: 0,
            olderKids: 0,
            preschoolers: 0,
            workers: 0,
        });
    const validation = Yup.object().shape({
        date: Yup.string()
            .transform(value => (value === null ? '' : value))
            .required(t('validations:required')),
        littleOnes: Yup.number().required(t('validations:required')),
        olderKids: Yup.number().required(t('validations:required')),
        preschoolers: Yup.number().required(t('validations:required')),
        workers: Yup.number().required(t('validations:required')),
    });

    useEffect(() => {
        getDeclaredPeople()
            .then((response) => {
                setDeclaredPeople({
                    date: response.data.date,
                    littleOnes: response.data.littleOnes,
                    olderKids: response.data.olderKids,
                    preschoolers: response.data.preschoolers,
                    workers: response.data.workers,
                });
            });
    }, []);

    const handleSubmit = (values) => {
        let item = {
            date: toDateString(values.date, DEFAULT_DATE),
            littleOnes: values.littleOnes,
            olderKids: values.olderKids,
            preschoolers: values.preschoolers,
            workers: values.workers,
        };
        setDeclaredPeople(item);
        declarePeople(item)
            .then(() => {
                alert.success(t('alert:saveSuccess'));
                handleClose();
            })
            .catch(() => alert.error(t('alert:saveError')));
    };

    const onClose = () => {
        handleClose();
    };

    const getFormModel = () => {
        let datePicker = {
            dateFormat: DEFAULT_DATE,
            showTime: false,
        };
        return {
            initValues: declaredPeople,
            onSubmit: (record) => handleSubmit(record),
            onCancel: () => onClose(),
            validationSchema: validation,
            fieldNames: ['date', 'littleOnes', 'olderKids', 'preschoolers', 'workers'],
            types: ['datePicker', 'number', 'number', 'number', 'number'],
            className: 'mb-3',
            label: [
                t('declarationDate'),
                t('monthMenu:littleOnes'),
                t('monthMenu:olderKids'),
                t('monthMenu:preschoolers'),
                t('monthMenu:workers'),
            ],
            selectData: [datePicker, null, null, null, null],
            inputFieldsClass: '',
        };
    };

    return (
        <>
            <button className={'button--main success-button'} onClick={handleShow} id={'declare-people-button'}>
                {t('declarePeople')}
            </button>
            <Modal show={show} onHide={onClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t('declarePeople')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BDSMForm form={getFormModel()} />
                </Modal.Body>
            </Modal>
        </>
    );
};